if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        slider: this.querySelector('[id^="Slider-Thumbnails"]'),
        sliderMedia: this.querySelector('[id^="Slider-Gallery"]'),
        thumbnailsArray: this.querySelectorAll('[id^="Slide-Thumbnails"]'),
        parentContainer: this.closest('section') || this,
        sliderViewport: this.querySelector('[id^="GalleryViewer"] .slider__viewport')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      // Register gallery reset on lightbox close BEFORE any early-return guards
      document.addEventListener('product-modal:close', () => {
        if (!this.elements.viewer) return;
        // ZGŁOSZENIE KLIENTA: Zawsze pierwsze zdjęcie na wierzchu na stronie po zamknięciu Lightboxa
        const firstMedia = this.elements.sliderMedia.querySelector('.product__media-item:not(.product__media-item--hide)');
        if (firstMedia) {
           this.elements.sliderMedia.querySelectorAll('li').forEach(item => item.classList.remove('is-active'));
           firstMedia.classList.add('is-active');
           this.elements.sliderMedia.scrollTo({ left: 0, behavior: 'instant' });
        }

        if (this.elements.thumbnails) {
           const firstThumb = this.elements.thumbnails.querySelector('.thumbnail-list__item');
           if (firstThumb) {
              this.elements.thumbnails.querySelectorAll('li').forEach(item => item.classList.remove('is-active'));
              firstThumb.classList.add('is-active');
           }
        }
      });

      if (!this.elements.thumbnails) return;
      this.elements.slider.addEventListener('click', this.setActiveThumbnail.bind(this))
      this.elements.slider.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ENTER') this.setActiveThumbnail(event)
      })
      if (this.dataset.desktopLayout !== 'one_column_grid' && this.dataset.desktopLayout !== 'two_columns_grid' && this.mql.matches) this.removeListSemantic();
    }

    setActiveMedia(mediaId) { 
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`)
      if (this.elements.viewer.querySelectorAll(`.product__media-item--hide`).length > 0 && activeMedia) {
        let activeMediaAlt = activeMedia.dataset.mediaAlt
        this.elements.viewer.querySelectorAll(`.product__media-item`).forEach(media => {
          media.classList.remove('product__media-item--variant-alt')
          if (media.dataset.mediaAlt == activeMediaAlt) media.classList.add('product__media-item--variant-alt')
        })
      } 
      else if (this.elements.viewer.querySelectorAll(`.product__media-item--hide`).length < 1) {
        const prevActiv = this.elements.viewer.querySelector(`.is-active`)
        if(prevActiv) prevActiv.classList.remove('is-active');
        if (activeMedia) activeMedia.classList.add('is-active');
      }
      if (!activeMedia) return
      if (activeMedia) {
        if(this.elements.sliderMedia.classList.contains('slider-main--original') && !this.elements.sliderMedia.classList.contains('grid--peek')) {
          let height = activeMedia.offsetHeight
          if(this.elements.parentContainer.offsetWidth < 769) {
            this.elements.sliderMedia.closest('.product--side_thumbnails') ? this.elements.sliderMedia.closest('.slider-block').removeAttribute('style') : this.elements.sliderMedia.removeAttribute('style')
            this.elements.sliderViewport.style.height = height + 'px'
          } else {
            this.elements.sliderViewport.removeAttribute('style')
            this.elements.sliderMedia.closest('.product--side_thumbnails') ? this.elements.sliderMedia.closest('.slider-block').style.height = height + 'px' : this.elements.sliderMedia.style.height = height + 'px'
          }
        }
        this.elements.sliderMedia.scrollTo({
          left: activeMedia.offsetLeft,
          behavior: 'smooth'
        })
      }
      if (this.querySelector('[id^="GalleryThumbnails"]')) {
        const prevActiveThumbnail = this.elements.thumbnails.querySelector(`.is-active`)
        if (prevActiveThumbnail) prevActiveThumbnail.classList.remove('is-active')
        let activeMediaAlt
        let mediaIdValue
        if (activeMedia) {
          activeMediaAlt = activeMedia.dataset.mediaAlt
          mediaIdValue = activeMedia.dataset.mediaId
        }
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaIdValue }"]`)
        if (activeThumbnail) activeThumbnail.classList.add('is-active')
        if (this.elements.viewer.querySelectorAll(`.product__media-item--hide`).length > 0 && activeMedia) {
          this.elements.thumbnails.querySelectorAll(`.thumbnail-list__item`).forEach(thumbnail => {
            thumbnail.classList.remove('product__media-item--variant-alt')
            if (thumbnail.dataset.mediaAlt == activeMediaAlt) thumbnail.classList.add('product__media-item--variant-alt')
          })
        } 
        this.elements.slider.scrollTo({
          left: activeThumbnail.offsetLeft - activeThumbnail.offsetWidth - 8,
          behavior: 'smooth'
        })
        if (activeThumbnail.parentElement.classList.contains('thumbnail-list--column')) {
          this.elements.thumbnails.scrollTo({
            top: activeThumbnail.offsetTop - activeThumbnail.offsetHeight - 8,
            behavior: 'smooth'
          })
        }
      }
      if (!activeMedia) return
      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.dataset.desktopLayout === 'one_column_grid' && !activeMedia.classList.contains('product__media-item--hide') || this.dataset.desktopLayout === 'two_columns_grid' && !activeMedia.classList.contains('product__media-item--hide')) {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);
      if (!this.elements.thumbnails) return;
      this.announceLiveRegion(activeMedia, this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`).dataset.mediaPosition);
    }

    setActiveThumbnail(event) {
      if(!event.target.closest('.thumbnail-list__item')) return;
      
      let newActiveThumb = event.target.closest('.thumbnail-list__item');
      let activeThumbData = newActiveThumb.dataset.target;
      let newActiveMedia = this.elements.sliderMedia.querySelector(`[data-media-id="${ activeThumbData }"]`);
      
      if (!newActiveMedia) return;

      // ZGŁOSZENIE KLIENTA: W głównej galerii ma być ZAWSZE AKTYWNE PIERWSZE ZDJĘCIE po kliknięciu innej miniatury
      const firstMedia = this.elements.sliderMedia.querySelector('.product__media-item:not(.product__media-item--hide)');
      const firstThumb = this.elements.thumbnails.querySelector('.thumbnail-list__item');
      if (firstMedia && firstThumb) {
         // Resetujemy "is-active" tylko dla głównej galerii w tle
         this.elements.sliderMedia.querySelectorAll('li').forEach(item => item.classList.remove('is-active'));
         this.elements.thumbnails.querySelectorAll('li').forEach(item => item.classList.remove('is-active'));
         firstMedia.classList.add('is-active');
         firstThumb.classList.add('is-active');
         
         // Zabezpieczenie scrolla w głównej galerii na pierwsze wideo/zdjęcie
         this.elements.sliderMedia.scrollTo({ left: 0, behavior: 'instant' });
      }
      
      const modalOpener = newActiveMedia.querySelector('modal-opener');
      if (modalOpener) {
         const modalSelector = modalOpener.getAttribute('data-modal');
         const modal = document.querySelector(modalSelector);
         if (modal) {
             const openerBtn = modalOpener.querySelector('button');
             modal.show(openerBtn || modalOpener);
             if (modalOpener.closest('.product__modal-opener')) {
                 let mediaId = openerBtn ? openerBtn.dataset.mediaId : activeThumbData;
                 document.dispatchEvent(new CustomEvent('product-modal:open', { detail: mediaId } ));
             }
         }
      }
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        if (image.closest('.lazy-image')) image.parentNode.classList.add('lazyloaded')
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
